(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('performance', {
                parent: 'dashboard',
                url: '/performance?fleet&objectType',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.performance.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/dashboards/performance/performance.html',
                        controller: 'PerformanceController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    fleet: {
                        value: '-1',
                        fleetName: true
                    },
                    objectType:{
                        value: '-1',
                        squash: true
                    }
                },

                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            fleet: $stateParams.fleet,
                            objectType: $stateParams.objectType
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('performance');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
